import React from 'react';
import innerCircleLogo from '../assets/innerCircle.png';
import './MaintenanceMode.css';

const MaintenanceMode = () => {
  return (
    <div className="maintenance-container">
      <div className="maintenance-logo-section">
        <img src={innerCircleLogo} alt="Valiram Inner Circle" className="maintenance-logo" />
      </div>
      
      <div className="maintenance-content">
        <h1 className="maintenance-title">
          WE'RE UPGRADING TO<br />
          SERVE YOU BETTER
        </h1>
        
        <div className="maintenance-text">
          <p className="maintenance-paragraph">
            Thank you for being part of the Valiram Inner Circle. We are making important upgrades to bring you a more seamless and rewarding loyalty experience.
          </p>
          
          <p className="maintenance-paragraph">
            As part of this transition, points earning and redemption are temporarily paused while we enhance our system and program structure.
          </p>
          
          <p className="maintenance-paragraph">
            During this transition, your points and account details are being reviewed and may be adjusted as we move to the new system. Rest assured, your information remains secure throughout this process.
          </p>
          
          <p className="maintenance-paragraph">
            We appreciate your continued support and look forward to bringing you an improved experience very soon.
          </p>
          
          <p className="maintenance-contact">
            For any enquiries, please contact our Customer Service team at <a href="mailto:cs@valiraminnercircle.com" className="contact-email">cs@valiraminnercircle.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
